import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);
const files = require.context("./modules", false, /\.js$/);
const modules = {};
files.keys().forEach((key) => {
  modules[key.replace(/(\.\/|\.js)/g, "")] = files(key).default;
});
Object.keys(modules).forEach((key) => {
  modules[key]["namespaced"] = true;
});
export default new Vuex.Store({
  state: {},
  getters: {},
  mutations: {},
  actions: {
    // 管理mutations
  },
  modules,
  plugins: [
    createPersistedState({
      reducer({ user, questionBank, examPaper, examBank, myExam, wrong }) {
        return {
          user,
          questionBank,
          examPaper,
          examBank,
          myExam,
          wrong,
        };
      },
    }),
  ],
});
